module.exports = __webpack_public_path__ + "img/takeout-img3.1b8e517e.png";